<template>
    <div>
          <div class="red_top">
              <div class="left">欢迎光临中一广告策划 官方网站</div>
              <div class="right">
                  <div class="list" @click="gotobottom()">官方微信</div>/
                  <div class="list">在线留言</div>/
                  <div class="list">客服咨询</div>/
                  <!-- <div class="list" @click="shoucan()">收藏中一官网</div>/ -->
                  <div class="list" @click="goTo('about_us?url=about_us')">关于中一</div>/
                  <div class="list" @click="goTo('about_us?url=about_us')">联系我们</div>
              </div>
          </div>

          <div class="index_top" :class="topindex == 1 ? 'index_fixe':''">
              <div class="logo">
                  <img src="~@/assets/logo2.png" alt="logo">
              </div>
              <div class="option">
                  <div class="list" @click="goTo('/?url=index')">首页</div>

                  <div class="list active" v-if="this.url == 'category'">
                      <div class="zh">案例展示</div>
                      <div class="en">CASE SHOW</div>
                  </div>
                  <div class="list" v-if="this.url != 'category'" @click="goTo('category?url=category')">案例展示</div>

                  <div class="list active" v-if="this.url == 'add_order'">
                      <div class="zh">方案定制</div>
                      <div class="en">PLAN CUSTOMIZE</div>
                  </div>
                  <div class="list" v-if="this.url != 'add_order'" @click="goTo('add_order?url=add_order')">方案定制</div>

                  <div class="list active" v-if="this.url == 'news'">
                      <div class="zh">新闻中心</div>
                      <div class="en">PLAN CUSTOMIZE</div>
                  </div>
                  <div class="list" v-if="this.url != 'news'" @click="goTo('news?url=news&sid=0')">新闻中心</div>


                  <div class="list active" v-if="this.url == 'about_us'">
                      <div class="zh">联系我们</div>
                      <div class="en">NEWS CENTER</div>
                  </div>
                  <div class="list" v-if="this.url != 'about_us'" @click="goTo('about_us?url=about_us')">联系我们</div>

                  <div class="list active" v-if="this.url == 'help'">
                      <div class="zh">帮助中心</div>
                      <div class="en">HELP CENTER</div>
                  </div>
                  <div class="list" v-if="this.url != 'help'" @click="goTo('help?url=help')">帮助中心</div>

                  <!-- <div class="list" @click="goTo('add_order?url=add_order')"></div> -->
                  <!-- <div class="list" @click="goTo('news?url=news')">新闻中心</div> -->
                  <!-- <div class="list" @click="goTo('help?url=help')">联系我们</div> -->

              </div>
              <div class="phone">
                  <div class="world">
                      <div class="title">免费服务热线</div>
                      <div class="number">180-2211-8773</div>
                  </div>
                  <img src="~@/assets/phone.png">
              </div>
          </div>
    </div>
</template>
      
<script>
export default {
  name: 'top',
  components: {
      
  },
  data () {
    return {
       topindex:0,
       url:'index'
    }
  },
  mounted () {
        window.addEventListener('scroll', this.windowScroll)
  },
  created: function () {
      this.url = this.$route.query.url
      console.log(this.url)
  },
  methods:{
      gotobottom(){
         document.querySelector('#bottom').scrollIntoView(true)
      },
      windowScroll() {
      // 滚动条距离页面顶部的距离
      // 以下写法原生兼容
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      
      if(scrollTop > 400){
          this.topindex = 1
      }else{
          this.topindex = 0
      }
    },
    goTo(url){
        this.$router.push(url);
    },
    shoucan(){
        window.external.addFavorite('http://www.zsfirst.com/','中一广告策划');  
        return false;
    }
  },
  destroyed(){
    window.removeEventListener('scroll',this.handleScroll)
  }
}
</script>

<style lang='scss' scoped>
$zycolor:#CF2C2E;
.index_top{
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo{
    width: 20%;
    height: 112px;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 244px;
      height: 50px;
    }
  }
  .option{
    width:  60%;
    height: 100px;
    display: flex;
    align-items: center;
    .list{
      // width: 100px;
      padding:0 30px;
      height: 50px;
      // background: $zycolor;
      color: #222;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      .en{
        font-size: 12px;
        margin-top:4px;
      }
    }
    .list:hover{
       background: $zycolor;
       color: #fff;
    }
    .active{
      background: $zycolor;
      color: #fff;
    }
  }
  .phone{
    width: 20%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    .world{
      margin-right:10px;
      height: 50px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      text-align: right;
      .number{
        font-size: 24px;
        font-weight: bold;
        color:$zycolor;
      }
    }
    img{
      width: 50px;
      height: 50px;
    }
  }
}
.index_fixe{
  position: fixed;
  top:0;
  left: 0;
  background: #fff;
  z-index: 120;
  border-bottom: 1px solid #eee;
  .option .list{
      color: #222;
  }
  .option .active{
      color: #fff;
  }
  .list:hover{
     background: $zycolor;
     color:#fff;
  }
}

.red_top{
    width: 100%;
    background: $zycolor;
    display: flex;
    justify-content: space-between;
    padding:5px 75px;
    box-sizing: border-box;
    color: #fff;
    align-items: center;
    .left{

    }
    .right{
        display: flex;
        align-items: center;
        .list{
            margin: 0 5px;
            cursor: pointer;
        }
        
    }
}
</style>